import React from 'react';
import styled from 'styled-components';
import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';
import Button from '@components/dataEntry/button/Button';

const Wrap = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const ButtonSec = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
type Props = {
  show: boolean;
  handleClose?: () => void;
  errorType: any;
};

function ErrorModal({ show, handleClose, errorType }: Props) {
  const { title, description } = errorType;
  return show ? (
    <ModalWrapper outsideClick={handleClose} contentStyle={{ maxWidth: 300 }}>
      <Wrap>
        <h5>
          <strong>{title}</strong>
        </h5>
        <p className="space-2x">{description}</p>
        <ButtonSec>
          <Button onClick={handleClose}>확인</Button>
        </ButtonSec>
      </Wrap>
    </ModalWrapper>
  ) : null;
}

export default ErrorModal;
